export const ServiceListEdit = {
  Title: 'マイメニューの編集',
  SubTitlePharmacy: '薬局',
  PharmacyService: {
    PharmacySearch: '薬局検索',
    FamilyPharmacy: 'かかりつけ薬局',
    FollowUpMessage: 'メッセージ',
  },
  SubTitleTools: '便利ツール',
  ToolsService: {
    Notice: 'お知らせ',
    FamilyList: '家族一覧',
    DataShare: 'お薬手帳の共有',
    Column: 'コラム',
  },
  SubTitleShopping: 'お買い物',
  ShoppingService: {
    EcShop: 'お買い物',
  },
  UpdateButton: '更新する',
};
